import http_request from "./http_request";
import { get_local_storage } from "./storage";

const department = get_local_storage('department')
export const postImage = async (id, files, action, detail) => {
  let formData = new FormData();
  for (var i = 0; i < files.length; i++) {
    let file = files[i];
    formData.append("images", file);
  }
  formData.append("id", id);
  formData.append("action", action);
  formData.append("detail", detail);
  formData.append("department", department);

  const res = await http_request({
    method: "POST",
    url: `upload/images`,
    data: formData,
    up_file: true,
  });

  const { code, data, message } = res;
  if (code === 200) {
    return data

  }
}
